import { Text } from '@medly-components/core';
import type { FC } from 'react';

import { DarkHeader, Header } from 'components/layout';

import { useIsMobile } from 'hooks';
import { HeaderStyled, HeaderTitleWrapper, TitleAndActionsWrapper } from './ListingPageHeader.styled';
import type { ListingPageHeaderProps } from './types';

export const ListingPageHeader: FC<ListingPageHeaderProps> = ({ title, tabs, filters, menu }) => {
    const isMobile = useIsMobile();

    return (
        <HeaderStyled>
            <DarkHeader>
                <HeaderTitleWrapper>
                    <Header.BackButton to={-1} />
                    {isMobile && <Text textVariant="body1">{title}</Text>}
                </HeaderTitleWrapper>
                {menu}
            </DarkHeader>
            <TitleAndActionsWrapper withBottomMargin={!tabs}>
                {!isMobile && <Text textVariant="h2">{title}</Text>}
                {filters}
            </TitleAndActionsWrapper>
            {tabs}
        </HeaderStyled>
    );
};
ListingPageHeader.displayName = 'ListingPageHeader';
